import { useTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../../shared/components/table/Table";

const ActionsPerformanceDataExplorerPreviewTable = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHeader>
        <TableRow>
          {data &&
            data.headers.map((header) => (
              <TableHead key={header}>{t(header)}</TableHead>
            ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data &&
          data.rows.map((row, index) => (
            <TableRow key={`row_#${index}`}>
              {Object.keys(row).map((key, rowIndex) => (
                <TableCell key={`${index}#${rowIndex}`}>{row[key]}</TableCell>
              ))}
            </TableRow>
          ))}
        {data && data.rows.length === 50 && (
          <TableRow key="last_row">
            <TableCell
              colspan={data.headers.length}
              className="text-center text-lg italic"
            >
              Existen más registros para descargar
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default ActionsPerformanceDataExplorerPreviewTable;
